import React from "react";

export const CupisLogo = () => <svg width="187" height="54" viewBox="0 0 187 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M146.485 0.196289H135.663V53.8027H146.485V0.196289Z" fill="#C5AE75"/>
<path d="M115.595 31.4749L88.492 0.393009H83.032V53.8027H94.0012V22.9176L120.907 53.8027H126.417V0.196289H115.595V31.4749Z" fill="#C5AE75"/>
<path d="M40.7778 53.8032H73.931V43.0327H51.5501V30.3442H73.931V19.7213H51.5501V10.8197H74.1277V0H40.7778V53.8032Z" fill="#C5AE75"/>
<path d="M154.256 11.0165H164.881V53.8033H175.653V11.0165H186.278V0.393555H154.256V11.0165Z" fill="#C5AE75"/>
<path d="M1.32809 11.0165H17.4621L0 48.3443V54H31.2842V43.4263H14.0188L31.2842 6.29524V0.590332H1.32809V11.0165Z" fill="#C5AE75"/>
</svg>
